// Geometry helper for the editor canvas ruler (flag REACT_APP_LOGO_CLONE_SIZE_FIX).
//
// The canvas <img> has a min/max box (450x325 .. 900x650) and object-fit, so
// the ELEMENT rectangle and the PAINTED bitmap rectangle differ whenever the
// bitmap's aspect ratio is outside the box's [450/650 ; 900/325] window - and
// always for the 180px mutation thumbnails, which object-scale-down never
// upscales (180px painted inside a >=450px box). A ruler that divides the
// element width by the logo's mm is then ~2.5x off. This computes where the
// bitmap actually sits (object-fit: contain semantics, centered) from the
// image's natural size, in the same viewport coordinates as the element rect.

export interface RectLike {
  left: number;
  top: number;
  width: number;
  height: number;
}

export interface NaturalSize {
  naturalWidth: number;
  naturalHeight: number;
}

export function getContainedImageRect(
  elementRect: RectLike,
  natural: NaturalSize
): RectLike {
  const { naturalWidth, naturalHeight } = natural;
  // Not loaded yet (naturalWidth/Height are 0 until the bitmap decodes) or a
  // degenerate box: fall back to the element rect - the historical measure.
  if (
    !(naturalWidth > 0) ||
    !(naturalHeight > 0) ||
    !(elementRect.width > 0) ||
    !(elementRect.height > 0)
  ) {
    return { ...elementRect };
  }
  const scale = Math.min(
    elementRect.width / naturalWidth,
    elementRect.height / naturalHeight
  );
  const width = naturalWidth * scale;
  const height = naturalHeight * scale;
  return {
    left: elementRect.left + (elementRect.width - width) / 2,
    top: elementRect.top + (elementRect.height - height) / 2,
    width,
    height,
  };
}
